import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Container from "@/views/Container";
import Authentication from "@/views/Authentication";
import Device from "@/views/device/Device";
import User from "@/views/user/User";
import Attendance from "@/views/attendance/Attendance";
import Docs from "@/views/docs/Docs";

Vue.use(VueRouter);

const routes = [
  {
    name: "Main",
    path: "/",
    component: Container,
    beforeEnter: (to, from, next) => {
      if (store.state.identity) {
        next();
      } else {
        next({ name: "Authentication" });
      }
    },
    redirect: "/devices",
    children: [
      {
        name: "Device",
        path: "devices",
        component: Device,
      },
      {
        name: "User",
        path: "users",
        component: User,
      },
      {
        name: "Attendance",
        path: "attendance",
        component: Attendance,
      },
      {
        name: "Docs",
        path: "docs",
        component: Docs,
      },
    ],
  },
  {
    name: "Authentication",
    path: "/auth",
    component: Authentication,
    beforeEnter: (to, from, next) => {
      if (store.state.identity) {
        next({ name: "Main" });
      } else {
        next();
      }
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
